import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import ListItemText from '@mui/material/ListItemText';
import CardMedia from '@mui/material/CardMedia';
import ImageList from '@mui/material/ImageList';
import useMediaQuery from '@mui/material/useMediaQuery';
import ImageListItem from '@mui/material/ImageListItem';
import { useTheme } from '@mui/material/styles';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';

import Container from 'components/Container';


const AnnualPrize4to52025 = () => {

    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
        fetch('/config.json')
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    const p1 = `${config.base_image_url_2025}/home/events-activities/Achievements/Scholastic/PrizeDayClass4to5/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/Achievements/Scholastic/PrizeDayClass4to5/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/Achievements/Scholastic/PrizeDayClass4to5/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/Achievements/Scholastic/PrizeDayClass4to5/4.webp`;
    const p5 = `${config.base_image_url_2025}/home/events-activities/Achievements/Scholastic/PrizeDayClass4to5/5.webp`;
    const p6 = `${config.base_image_url_2025}/home/events-activities/Achievements/Scholastic/PrizeDayClass4to5/6.webp`;

    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };
    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        },
        {
            src: p6,
            source: p6,
            rows: 1,
            cols: 1,
        }
    ];

    return (
        <Container>
            <Box>
                <Box marginBottom={4}>
                    <Typography fontWeight={700} variant={'h4'} align={'center'}>
                        PRIZE DAY 2025-26
                    </Typography>
                    <br />
                    <Typography
                        fontSize="x-small"
                    ><br /><br />
                        Classes: 4 and 5      Date: 06 February 2026
                    </Typography>
                    <Typography variant={'subtitle1'} align={'justify'}>
                        The Prize Distribution Ceremony for students of Classes 4 and 5 was organised on Friday, 6th February 2026 to recognise their achievements in Sports and Co-Curricular Activities. The programme began with a warm welcome, followed by an inspiring address by Principal Ma’am, appreciating the students’ enthusiasm, discipline and active participation throughout the year. The Vice Principal and Coordinators also congratulated and encouraged the students to continue developing their talents along with academics.
                        <br></br>
                        Certificates were distributed to students who excelled in various Sports and Co-Curricular Activities celebrating their effort and dedication. The confidence and joy of the young achievers reflected the spirit of healthy competition nurtured by the school. The ceremony concluded on a happy and motivating note, reinforcing the institution’s commitment to the holistic development and growth of every child.
                        <br></br>
                        <div>
                        </div>
                    </Typography>
                </Box>
                <Typography
                    variant={'h6'}
                    color={'primary'}
                    align={'center'}
                    fontWeight={'normal'}
                ><br />
                    "Where Confidence Grows and Talents Glow.""
                    <br />
                    <br />
                </Typography>
                <Box>
                    <ImageList
                        variant="quilted"
                        cols={2}
                        rowHeight={isMd ? 300 : 200}
                        gap={isMd ? 16 : 4}
                    >
                        {photos.map((item, i) => (
                            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                <LazyLoadImage
                                    height={'100%'}
                                    width={'100%'}
                                    src={item.src}
                                    alt="..."
                                    effect="blur"
                                    onClick={() => openLightbox(i)}
                                    style={{
                                        objectFit: 'cover',
                                        filter:
                                            theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                        cursor: 'poiner',
                                        borderRadius: 8,
                                    }}
                                />
                            </ImageListItem>
                        ))}
                    </ImageList>
                </Box>
                {viewerIsOpen && (
                    <Lightbox
                        mainSrc={photos[currentImage].src}
                        nextSrc={photos[(currentImage + 1) % photos.length].src}
                        prevSrc={
                            photos[(currentImage + photos.length - 1) % photos.length].src
                        }
                        onCloseRequest={() => closeLightbox()}
                        onMovePrevRequest={() =>
                            setCurrentImage((currentImage + photos.length - 1) % photos.length)
                        }
                        onMoveNextRequest={() =>
                            setCurrentImage((currentImage + 1) % photos.length)
                        }
                        reactModalStyle={{ overlay: { zIndex: 1500 } }}
                    />
                )}
                {/* </Box> */}
            </Box>
        </Container>
    );
};

export default AnnualPrize4to52025;